import type { FeatureGridBlock as FeatureGridBlockType } from "@/types";

/** "What's included" (CD scope grid). Optional eyebrow + heading, then a
 *  bordered grid of numbered cards (01, 02, …) — each with a heading and a
 *  short body. Numbers are derived from order, so no icon system is needed. */
export function FeatureGridBlock({ block }: { block: FeatureGridBlockType }) {
  const { eyebrow, heading, items } = block.props;
  const visible = (items ?? []).filter((it) => it.title || it.body);
  if (visible.length === 0 && !heading) return null;

  return (
    <section className="block block--feature-grid">
      {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
      {heading ? <h2 className="block--feature-grid__heading">{heading}</h2> : null}
      <ol className="block--feature-grid__list">
        {visible.map((item, i) => (
          <li className="block--feature-grid__item" key={i}>
            <span className="num numeric block--feature-grid__num">
              {String(i + 1).padStart(2, "0")}
            </span>
            {item.title ? <h3 className="block--feature-grid__title">{item.title}</h3> : null}
            {item.body ? <p className="block--feature-grid__body">{item.body}</p> : null}
          </li>
        ))}
      </ol>
    </section>
  );
}
